const locale = {
  placeholder: 'æå»ãé¸æ',
};

export default locale;
